const styles = {
  photoHeading: {
    fontSize: "16px",
    margin: "20px 0px 8px 0px",
  },
  photo: {
    width: "100%",
    maxWidth: "1024px",
    maxHeight: "600px",
    objectFit: "contain",
    objectPosition: "left",
  },
  instagramPhoto: {
    height: "650px",
    width: "85%",
  },
  photoDescription: {
    fontSize: "14px",
  },
  figure: {
    padding: 0,
    margin: 0,
  },
};

export default styles;
